<ng-container *ngIf="!isLoading">
  <mat-dialog-content>
    <mat-card-title>
      {{'ecase.admindashboard.competitions.awardFinalization.manage.cycle'| eCaseTranslate}}</mat-card-title>
    <div style="width: 100%">
      <button style="float: right;margin-right: 0 !important;" mat-raised-button class="eCase-dialog-positive-action-button"
              (click)="onEdit(undefined)">
        {{'ecase.admindashboard.competitions.awardFinalization.manage.add.cycle'| eCaseTranslate}}
      </button>
    </div>
    <table (matSortChange)="sortColumn($event)" [@animateStagger]="{value:'50'}" [dataSource]="dataSource" class="ecase-mat-table"
           id="ecase_admindashboard_competitions_competition_manage_cycle_table" mat-table matSort matSortActive="{{sortActive}}" matSortDirection="{{sortDirection}}">
      <ng-container matColumnDef="description">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>
          <u>
            {{'ecase.common.approvalCycle.approvalCycleDescription' | eCaseTranslate}}
          </u>
        </th>
        <td *matCellDef="let row" [title]="'ecase.common.approvalCycle.approvalCycleDescription' | eCaseTranslate" mat-cell>
          {{row.description}}</td>
      </ng-container>
      <ng-container matColumnDef="formattedLastUpdateDate">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>
          <u>
            {{'ecase.admindashboard.competitions.awardFinalization.manage.cycle.formattedLastUpdateDate' | eCaseTranslate}} <br>({{'ecase.defaultDatetime' | translate}})
          </u>
        </th>
        <td *matCellDef="let row" [title]="'ecase.admindashboard.competitions.awardFinalization.manage.cycle.formattedLastUpdateDate' | eCaseTranslate" class="tdStyle" mat-cell>
          {{row.formattedLastUpdateDate}}
        </td>
      </ng-container>
      <ng-container matColumnDef="lastUpdateBy">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>
          <u>
            {{'ecase.admindashboard.competitions.awardFinalization.manage.cycle.lastUpdateBy' | eCaseTranslate}}
          </u>
        </th>
        <td *matCellDef="let row" [title]="'ecase.admindashboard.competitions.awardFinalization.manage.cycle.lastUpdateBy' | eCaseTranslate" class="tdStyle" mat-cell>
          {{row.lastUpdateBy}}
        </td>
      </ng-container>
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef><span class='nodisplay'>.</span>
        </th>
        <td mat-cell *matCellDef="let row" [title]="'ecase.common.action' | eCaseTranslate">
          <button (click)="menuTrigger.openMenu();$event.stopPropagation()" #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu" class="mat-icon-button eCase-in-table-mat-button" id="ecase_competition_manage_cycle_table_action" aria-label="{{'ecase.common.table.actionMore'| translate }}" matTooltip="{{'ecase.common.table.actionMore'| translate}}">
            <mat-icon>more_vert</mat-icon>
            <span>
              {{ 'ecase.common.action' | eCaseTranslate }}
            </span>
          </button>
          <mat-menu #menu="matMenu">
            <div>
              <button mat-menu-item [disabled]="isCompetitionClosed" (click)="onEdit(row)" id="ecase_competition_manage_cycle_edit">
                {{'ecase.admindashboard.competitions.awardFinalization.manage.cycle.action.edit' | translate}}
              </button>
              <button mat-menu-item [disabled]="isCompetitionClosed" (click)="onDelete(row)" id="ecase_competition_manage_cycle_delete">
                {{'ecase.common.table.actionDelete' | translate}}
              </button>
            </div>
          </mat-menu>
        </td>
      </ng-container>
      <ng-container class="filter_row_first_cell mat-elevation-z4" matColumnDef="header-row-first-group" matRipple>
        <th *matHeaderCellDef class="mat-table_filtered_header_cell" mat-header-cell>
          <span class='nodisplay'>.</span>
          <input *ngIf="showImage" alt="clear" class="row_filter_icon" disabled matRipple src="/assets/images/etc/icons8-conversion.svg" type="image">
          <input (click)="resetFilters(true)" *ngIf="!showImage" alt="clear" class="row_filter_icon" src="/assets/images/etc/icons8-clear-filters.svg" type="image">
          <input (keyup)="applyFilter()" [(ngModel)]="filterObject.description" [attr.aria-label]="'ecase.admindashboard.competitions.awardFinalization.manage.cycle.description' | eCaseTranslate" [placeholder]="'ecase.admindashboard.admintools.eligibility.searchResult.search' | eCaseTranslate" class="searchFields" id="ecase_competition_manage_cycle_table_description_filter" type="text">
        </th>
      </ng-container>
      <ng-container matColumnDef="header-row-second-group">
        <th *matHeaderCellDef class="mat-table_filtered_header_cell" mat-header-cell>
          <span class='nodisplay'>.</span>
          <input (keyup)="applyFilter()" [(ngModel)]="filterObject.formattedLastUpdateDate" [attr.aria-label]="'ecase.admindashboard.competitions.awardFinalization.manage.cycle.formattedLastUpdateDate' | eCaseTranslate" [placeholder]="'ecase.admindashboard.admintools.eligibility.searchResult.search' | eCaseTranslate" class="searchFields" id="ecase_competition_manage_cycle_table_date_filter" type="text">
        </th>
      </ng-container>
      <ng-container matColumnDef="header-row-third-group">
        <th *matHeaderCellDef class="mat-table_filtered_header_cell" mat-header-cell>
          <span class='nodisplay'>.</span>
          <input (keyup)="applyFilter()" [(ngModel)]="filterObject.lastUpdateBy" [attr.aria-label]="'ecase.admindashboard.competitions.awardFinalization.manage.cycle.lastUpdateBy' | eCaseTranslate" [placeholder]="'ecase.admindashboard.admintools.eligibility.searchResult.search' | eCaseTranslate" class="searchFields" id="ecase_competition_manage_cycle_table_user_filter" type="text">
        </th>
      </ng-container>
      <ng-container matColumnDef="header-row-fourth-group">
        <th mat-header-cell *matHeaderCellDef class="mat-table_filtered_header_cell"><span class='nodisplay'>.</span>
        </th>
      </ng-container>
      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr *matHeaderRowDef="['header-row-first-group', 'header-row-second-group', 'header-row-third-group','header-row-fourth-group']" mat-header-row></tr>
      <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>
    </table>
    <mat-paginator [length]=originalArray.length [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" showFirstLastButtons></mat-paginator>
    <span>
      {{dataSource.data.length }} {{'ecase.common.table.numberOfEntryFound' | eCaseTranslate}}</span>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button style="float: left; margin-top: 2%; background-color: #EF5350; color: #FFFFFF" (click)="onCloseDialog()">
      {{ 'ecase.common.close' | translate }}</button>
  </mat-dialog-actions>

</ng-container>
<ng-container *ngIf="isLoading">
  <mat-dialog-content>
    <div style="margin: 0 auto">
      <app-loading-spinner></app-loading-spinner>
    </div>
  </mat-dialog-content>

</ng-container>
